"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assetFolderDeletefetch = exports.assetFolderDeleteSuccess = exports.assetFolderDeleteSoftDelete = exports.assetFolderDeleteRestoreBulk = exports.assetFolderDeleteRestore = exports.assetFolderDeleteReset = exports.assetFolderDeleteHardDeleteBulk = exports.assetFolderDeleteError = void 0;
var _assetFolderDelete = require("./assetFolderDelete.constant");
// @flow

// common success
var assetFolderDeleteSuccess = function assetFolderDeleteSuccess(actionType, data) {
  return {
    type: _assetFolderDelete.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.assetFolderDeleteSuccess = assetFolderDeleteSuccess;
var assetFolderDeleteError = function assetFolderDeleteError(actionType, error) {
  return {
    type: _assetFolderDelete.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * hard delete bulk
 * @param payload
 * @returns api response
 * @description this function used to hard delete bulk asset.
 */
exports.assetFolderDeleteError = assetFolderDeleteError;
var assetFolderDeleteHardDeleteBulk = function assetFolderDeleteHardDeleteBulk(data) {
  return {
    type: _assetFolderDelete.actionTypes.HARD_DELETE_BULK,
    payload: data
  };
};

/**
 * restore bulk
 * @param payload
 * @returns api response
 * @description this function used to restore bulk asset.
 */
exports.assetFolderDeleteHardDeleteBulk = assetFolderDeleteHardDeleteBulk;
var assetFolderDeleteRestoreBulk = function assetFolderDeleteRestoreBulk(data) {
  return {
    type: _assetFolderDelete.actionTypes.RESTORE_BULK,
    payload: data
  };
};

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to fetch asset.
 */
exports.assetFolderDeleteRestoreBulk = assetFolderDeleteRestoreBulk;
var assetFolderDeletefetch = function assetFolderDeletefetch(data) {
  return {
    type: _assetFolderDelete.actionTypes.FETCH,
    payload: data
  };
};

/**
 * restore
 * @param payload
 * @returns api response
 * @description this function used to restore asset.
 */
exports.assetFolderDeletefetch = assetFolderDeletefetch;
var assetFolderDeleteRestore = function assetFolderDeleteRestore(data) {
  return {
    type: _assetFolderDelete.actionTypes.RESTORE,
    payload: data
  };
};

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft delete asset.
 */
exports.assetFolderDeleteRestore = assetFolderDeleteRestore;
var assetFolderDeleteSoftDelete = function assetFolderDeleteSoftDelete(data) {
  return {
    type: _assetFolderDelete.actionTypes.SOFTDELETE,
    payload: data
  };
};

/**
 * reset asset folder
 * @param payload
 * @returns api response
 * @description this function used to reset asset.
 */
exports.assetFolderDeleteSoftDelete = assetFolderDeleteSoftDelete;
var assetFolderDeleteReset = function assetFolderDeleteReset() {
  return {
    type: _assetFolderDelete.actionTypes.RESET
  };
};
exports.assetFolderDeleteReset = assetFolderDeleteReset;